import GoogleMapBaseStyle from './GoogleMapBaseStyle';

const GoogleMapHybridPOIOffStyle = [
  ...GoogleMapBaseStyle,
  {
    featureType: 'poi',
    elementType: 'all',
    stylers: [ {
      visibility: 'off',
    } ],
  },
];

export default GoogleMapHybridPOIOffStyle;
